import { render } from "./Latest.vue?vue&type=template&id=6b7ad6df&scoped=true"
import script from "./Latest.vue?vue&type=script&lang=js"
export * from "./Latest.vue?vue&type=script&lang=js"

import "./Latest.vue?vue&type=style&index=0&id=6b7ad6df&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7ad6df"]])

export default __exports__